import React, { Component } from 'react';
import PostInput from '../../Shared/PostInput';
import {connect} from "react-redux"
import {addBlog} from '../../redux/action/blogAction'
// ES6
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import {updateWork} from '../../redux/action/worksAction'
// CommonJS

class UpdateWorkPage extends Component {

  state = {
    unique_title: this.props.location.state.oldWork.unique_title,
    title: this.props.location.state.oldWork.title,
    work: this.props.location.state.oldWork.work,
    description: this.props.location.state.oldWork.description,
    date: this.props.location.state.oldWork.date,
  }

  handleValueText = (e) => {
    this.state.work = e    
  }
  handleValueTextdescription= (e) => {
    this.state.description = e    
  }

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    })
  }

  handleSubmit = (e) => {
    // console.log("the data you want to update is", this.props.location.state.oldBlog)
    e.preventDefault();
    this.props.updateWork(this.props.location.state.oldWork,this.state);
    // console.log(this.state)
    // console.log("Hi")
  }

  render() {
    
    return (
      <div className="content" id ="content">
            <div className="panel-center">
            </div>


                <form 
                    id="addTaskForm"
                    className="container"
                    autoComplete="off"
                    onSubmit={this.handleSubmit}
                >
                <div className="panel-center">
                    
                    <input type="text" placeholder="Unique title" className="inputEnter" id="unique_title" onChange={this.handleChange} defaultValue={this.state.unique_title}/>
                    <input type="text" placeholder="Titile here.." className="inputEnter" id="title" onChange={this.handleChange} defaultValue={this.state.title}/>
                    <input type="number" placeholder="Category 1-6" className="inputEnter" id="category" onChange={this.handleChange} defaultValue={this.state.category}/>

                    <input type="datetime-local" placeholder="Date" className="inputEnter" id="date" onChange={this.handleChange} defaultValue={this.state.date}/>
                   
                    <select id="status" onChange={this.handleChange}>
                      <option value="public">Publish</option>
                      <option value="draft">Draft</option>
                    </select>

                  {/* <textarea placeholder="Description" id="description" onChange={this.handleChange}></textarea> */}
                  <p>Description</p>
                  <PostInput handleValueText={this.handleValueTextdescription} valueText={this.state.description}/>
                  <hr></hr>
                  <p>Content</p>
                  <PostInput handleValueText={this.handleValueText} valueText={this.state.work}/>

                  {/* <ReactQuill
                      onChange={this.handleValueText} 
                      // onChange={this.previewCode}
                      theme="snow"                      
                  /> */}

                </div>
                  <div className="panel-left">
                    <button>Update the work</button>
                  </div>
                </form>
               
             
              </div>

    )
  }

}


const mapDispatch = dispatch => {
  return {
    updateWork: (work, newWork) => dispatch(updateWork(work, newWork))
  }
}

export default connect(null, mapDispatch) (UpdateWorkPage);
